export default {
  eyebrow: 'Partnerportal',
  title: 'Servicegebühr-Rechner',
  description:
    'Schätzen Sie den Servicegebühr-Umsatz, den die Restaurants unter Ihrem Partnerkonto insgesamt erzielen.',
  toasts: {
    load_error: 'Ihre Servicegebühr-Einstellungen konnten nicht geladen werden.',
  },
};
